import { AxiosResponse } from 'axios'
import { IShipment } from '../components/Applications/GuestApps/interfaces'
import { GetRelationsResponse } from './apiInterfaces'
import { axiosInstanceEntityGuest } from './axiosInstance'
import { handleError, handleResponse } from './dtServices'
import { IAppSettingsParams, ISettingsResponse } from './applications'
import { IRelation } from '../components/DTStudio/interfaces'

export const makeGuestAPIRequest = async <T, D = null, P = null>(
    method: 'get' | 'post' | 'put' | 'delete',
    url: string,
    data?: D,
    params?: P,
    successMessage?: string,
    errorMessage?: string,
    throwError?: boolean,
): Promise<T> => {
    try {
        const response: AxiosResponse<T> = await axiosInstanceEntityGuest({
            method,
            url,
            data,
            params,
        })
        return handleResponse(response, successMessage)
    } catch (err) {
        const handledErrorMessage: string =
            handleError(err, errorMessage, throwError) ?? ''
        if (throwError && !!handledErrorMessage) {
            throw new Error(handledErrorMessage)
        }
        return undefined as unknown as T
    }
}

export const getShipmentIdbyTripNumber = async (
    tripNumber: string,
): Promise<IShipment[]> => {
    try {
        const TrimedTripNumber = tripNumber?.trim() || ''
        const response = await makeGuestAPIRequest<IShipment[], null, null>(
            'get',
            `/coldChain/public/shipment/${TrimedTripNumber}`,
            null,
            null,
            '',
            '',
            true,
        )
        return response ?? []
    } catch (error: unknown) {
        throw new Error((error as Error)?.message as string)
    }
}

export const getShipmentByShipmentId = async (
    shipmentId: string,
): Promise<IShipment> => {
    try {
        const response = await makeGuestAPIRequest<IShipment, null, null>(
            'get',
            `/coldChain/public/shipmentData/${shipmentId}`,
            null,
            null,
            '',
            '',
            true,
        )
        return response
    } catch (error: unknown) {
        throw new Error((error as Error)?.message as string)
    }
}

export const getApplicationSettingsForGuest = async <T>(
    orgId: string,
    applicationName: string,
): Promise<ISettingsResponse<T>> => {
    return makeGuestAPIRequest<ISettingsResponse<T>, null, IAppSettingsParams>(
        'get',
        `/coldChain/public/settings`,
        null,
        {
            applicationName,
            orgId,
        },
    )
}

export const fetchRelationsForGuest = async (
    entityId: string,
    orgId: string,
): Promise<IRelation[]> => {
    const response = await makeGuestAPIRequest<GetRelationsResponse>(
        'get',
        `/coldChain/public/relation/${entityId}?orgId=${orgId}`,
    )
    return response?.entityRelationData ?? []
}
